import { ReportSelectOptionType } from 'types/reports';

export const getReportById = (
  reports: ReportSelectOptionType[] = [],
  reportId: string | null,
  defaultReportId: string
) => {
  if (reportId) {
    const matched = reports.find(
      r =>
        r.value === reportId ||
        (r.reportData &&
          r.reportData.pbiView &&
          r.reportData.pbiView.id === reportId)
    );
    if (matched && matched.reportData) {
      return matched.reportData;
    }
  }

  const defaultMatched = reports.find(
    r =>
      r.value === defaultReportId ||
      (r.reportData &&
        r.reportData.pbiView &&
        r.reportData.pbiView.id === defaultReportId)
  );
  return defaultMatched && defaultMatched.reportData
    ? defaultMatched.reportData
    : undefined;
};
